import { Box, type ChakraProps, Flex, Heading } from "@chakra-ui/react"
import React from "react"
import { STATIC_PAGE_HEADER_HEIGHT } from "../../common/commonConstants"
import { Colors } from "../../theme/colors"

interface StaticPageHeaderProps {
  children?: React.ReactNode
  title?: string
  bg: string
  headingProps?: ChakraProps
  imageOpacity?: number
  props?: ChakraProps
}

export const StaticPageHeader = ({ children, title, bg, headingProps, imageOpacity, props }: StaticPageHeaderProps): JSX.Element => {
  return (
    <Box
      w="100%"
      pos="relative"
      h={STATIC_PAGE_HEADER_HEIGHT}
      backgroundSize="cover"
      backgroundPosition={"50% 50%"}
      backgroundImage={`url(${bg})`}
      backgroundRepeat={"no-repeat"}
      {...props}
    >
      <Flex pos={"absolute"} top="0" zIndex="2" bg={Colors.Primary.white} align={"center"} flexDir="column" height="100%"></Flex>
      <Flex flexDir={"column"} align={"center"} justify={"center"} flexWrap={"wrap"} h={"100%"} bg="rgba(255,255,255,0.75)">
        {title && (
          <Heading
            m="0"
            p="0"
            color={"primary"}
            variant="Heading1SemiBold"
            maxW="894px"
            textAlign={"center"}
            fontSize={["40px"]}
            {...headingProps}
            w={["320px", "320px", "320px", "100%"]}
          >
            {title}
          </Heading>
        )}

        {children && <Box>{children}</Box>}
      </Flex>
    </Box>
  )
}
